import React from 'react';
import PropTypes from 'prop-types';
import { FileUpload } from '@telus-uds/components-base';

import { FieldWrapper, FieldLabelWrapper } from './css';
import FieldGuide from './common/fieldGuide';
import FieldTitle from './common/FieldTitle';

const FieldFile = ({ data }) => {
  const {
    name,
    label,
    required,
    onChange,
    tooltip,
    allowedFileTypes,
    tooltipLong,
    toolTipRichText,
    isLabelBold
  } = data;
  const tooltipMessage = tooltip || tooltipLong || toolTipRichText;

  // Parse allowedFileTypes string like ".pdf,.doc,.xlsx" into array ['pdf', 'doc', 'xlsx']
  const fileTypes = allowedFileTypes
    ? allowedFileTypes.split(',').map(t => t.trim().replace(/^\./, ''))
    : undefined;

  const handleUpload = async (files) => {
    // Simulate a file input change event for the form engine
    const syntheticEvent = {
      target: {
        name,
        files,
        value: files[0] ? files[0].name : ''
      }
    };
    onChange(syntheticEvent);
    return files.map(f => f);
  };

  const handleDelete = async () => {
    onChange({ target: { name, files: null, value: '' } });
    return {};
  };

  return (
    <FieldWrapper>
      <div>
        <FieldLabelWrapper>
          <FieldTitle required={required} label={label} isLabelBold={isLabelBold} />
          {tooltipMessage && (
            <FieldGuide tooltip={tooltipMessage} isRichText={toolTipRichText} />
          )}
        </FieldLabelWrapper>
      </div>
      <FileUpload
        fileTypes={fileTypes}
        onUpload={handleUpload}
        onDelete={handleDelete}
      />
    </FieldWrapper>
  );
};

FieldFile.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    required: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    tooltip: PropTypes.string,
    tooltipLong: PropTypes.string,
    toolTipRichText: PropTypes.shape({
      content: PropTypes.arrayOf(PropTypes.object)
    }),
    allowedFileTypes: PropTypes.string,
    isLabelBold: PropTypes.bool
  }).isRequired
};

export default FieldFile;
